'use client';

import {
  CREDITS_OPTIMISTIC_RELEASE_EVENT,
  CREDITS_OPTIMISTIC_RESERVE_EVENT,
  CREDITS_REFRESH_EVENT,
  applyOptimisticCreditReservation,
  refreshCreditsQueries,
  releaseOptimisticCreditReservation,
} from '@/hooks/credits/credits-refresh';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export function CreditsRefreshSync() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleCreditsRefresh = () => {
      void refreshCreditsQueries(queryClient);
    };
    const handleOptimisticReserve = (event: Event) => {
      applyOptimisticCreditReservation(
        queryClient,
        (event as CustomEvent<number>).detail
      );
    };
    const handleOptimisticRelease = (event: Event) => {
      releaseOptimisticCreditReservation(
        queryClient,
        (event as CustomEvent<number>).detail
      );
    };

    window.addEventListener(CREDITS_REFRESH_EVENT, handleCreditsRefresh);
    window.addEventListener(
      CREDITS_OPTIMISTIC_RESERVE_EVENT,
      handleOptimisticReserve
    );
    window.addEventListener(
      CREDITS_OPTIMISTIC_RELEASE_EVENT,
      handleOptimisticRelease
    );

    return () => {
      window.removeEventListener(CREDITS_REFRESH_EVENT, handleCreditsRefresh);
      window.removeEventListener(
        CREDITS_OPTIMISTIC_RESERVE_EVENT,
        handleOptimisticReserve
      );
      window.removeEventListener(
        CREDITS_OPTIMISTIC_RELEASE_EVENT,
        handleOptimisticRelease
      );
    };
  }, [queryClient]);

  return null;
}
